import React from 'react'
import GifIconLoading from '../assets/gif/mainLoading.gif';
import '../css/gifAnim.css';

function GifAnim(props) {

  const {
        hasBg = true
    } = props;

    return (
      <div className={ hasBg ? 'mainContentViewContainerGifAnim' : 'mainContentViewContainerNoBGGifAnim' }>
          <div className='manImgViewContainerGifAnim'>
              <img src={GifIconLoading} alt="gif" className='mainGifContainerGifAnim'/>
          </div>
      </div>
    )
}

export default GifAnim